<template>
  <div :class="['golf-outer', dataReady ? 'loaded' : '']" class="for-max-width-measure">
    <quiz-board :isPractice=true v-if="showQuizBoard && !showFinalScore" @proceedToQuiz="showQuizBoard=false" />
    <div class="home-page" v-else-if="!showQuizBoard && !showFinalScore" v-loading="showLoader">
      <timer-loader :show="showTimerLoader" @proceed="proceed" />
      <div class="free-play-details game-outer">
        <div class="total-scrore">{{ totalScore }}<span>stig</span></div>
        <div id="mySidenav" class="cross-btn">
          <button v-if="sharePage" class="closebtn" @click="goBackToShare">&times;</button>
          <a v-else href="javascript:history.back()" class="closebtn" onclick="closeNav()">&times;</a>
        </div>
        <div class="free-play-inner animate-slidein">
          <div v-if="freePlayInfo && freePlayInfo.questions && freePlayInfo.questions[questionIndex]">
            <timer :timerHeight=116 :timerWidth=116 :initTimer="timerVal" :hasTimerStart=hasTimerStart :questionKey="freePlayInfo.questions[questionIndex].key" @clickAnswer="clickAnswer" />
            <status-bar :answerSheet="currentLevelAnswers" />
            <div class="answer" :class="[selected && !freePlayValidate ? 'invalid' : '']">
              <span v-show="!!selected && freePlayValidate !== null">{{ freePlayValidate ? 'Rétt svar' : 'Rangt svar' }}</span>
            </div>
            <div class="hyphen mobile-view"></div>
            <div class="query-box question-block-inner">
              <p class="question">{{freePlayInfo.questions[questionIndex].question}}</p>
              <div class="radio">
                <div class="selection" v-for="(option,index) in freePlayInfo.questions[questionIndex]['options']" :key="option" :class="[selected==option ? 'selected' : '', selected==option && freePlayValidate !== null && freePlayValidate ? 'valid' : '', selected==option && freePlayValidate !== null && !freePlayValidate ? 'invalid' : '']">
                  <label class="radio-label" :class="[selected==option ? 'selected' : '']" :for="index">  {{option}}
                    <input id="answer1" :value="option" name="answer-one" type="radio" v-model="selected" v-on:change="clickAnswer(freePlayInfo.questions[questionIndex].key, selected)" :disabled="selected">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="status-image">
        <img src="/static/images/regluvardar_crown_logo.png" alt="logo" />
      </div>
    </div>
    <div class="final-score-page" v-else>
      <div class="inner animate-slidein">
        <h3>{{ success_greeting.title }}</h3>
        <div class="score-info">
          <span class="txt">Stig</span>
          <span class="total">{{ totalScore }}</span>
          <span class="divider"></span>
          <span class="out-of">Þú svaraðir {{ currentLevelAnswers.filter(Boolean).length }} af {{ questionLimit }} spurningum rétt</span>
          <status-bar :answerSheet="currentLevelAnswers" />
        </div>
        <h5>{{ success_greeting.greet_text }}</h5>
      </div>
      <div class="btn-wrapper animate-slidein">
        <a href="/innskraning/" class="button">{{ success_greeting.call_to_text }}</a>
        <button type="button" class="button" @click="continuePlay">{{ success_greeting.call_to_text_two }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/shared/api'
import { LevelInfo, GreetingInfo } from '@/shared/dataModels'
export default {
  name: 'FreePlay',
  data () {
    return {
      showFinalScore: false,
      dataReady: false,
      freePlayInfo: null,
      questionIndex: 0,
      questionLimit: 1,
      fullName: null,
      userGameInfo: {},
      currentLevelAnswers: [],
      freePlayValidate: null,
      showLoader: false,
      selected: null,
      sharePage: false,
      maxIndicators: 10,
      timerVal: 0,
      hasTimerStart: false,
      totalScore: 0,
      currentLevel: new LevelInfo(),
      showTimerLoader: false,
      success_greeting: new GreetingInfo(),
      showQuizBoard: true,
    }
  },
  created () {
    if (this.$data.globalData.user) {
      this.fullName = this.$data.globalData.user.name
    }
    this.getQuestions()

    if (this.$route.query) {
      if (this.$route.query.name) this.sharePage =  true
      // this.$router.replace('/frjals-spilun/')
    }
    this.hasTimerStart = true
  },
  watch: {
    currentLevelAnswers: {
      handler(newVal) {
        if (this.questionIndex < this.questionLimit) {
          this.currentLevelAnswers[this.questionIndex] = 'current'
        }
        if (this.questionIndex + 1 == this.questionLimit) {
          this.currentLevelAnswers = newVal
        }
      },
      immediate: true,
    },
  },
  methods: {
    getQuestions () {
      this.showLoader = true
      API.meInstance.get('/free-play/questions/').then((res) => {
        this.dataReady = true
        this.showLoader = false
        this.questionIndex = 0
        this.freePlayInfo = res.data.data
        this.questionLimit = res.data.data.questions.length
        this.currentLevelAnswers = Array(this.questionLimit).fill(null)
        this.timerVal = res.data.data.level_info.seconds_per_question
        this.success_greeting = res.data.data.greeting_success[0]
        if (res.data.data.level_info) {
          const levelInfo = res.data.data.level_info
          this.currentLevel['key'] = levelInfo['key']
          this.currentLevel['name'] = levelInfo['name']
          this.currentLevel['level'] = levelInfo['level']
          this.currentLevel['minimum_valid_answers'] = levelInfo['minimum_valid_answers']
          this.currentLevel['points_per_answer'] = levelInfo['points_per_answer']
          this.currentLevel['questions_per_level'] = levelInfo['questions_per_level']
          this.currentLevel['correctAnswers'] = 0
          this.currentLevel['invalidAnswers'] = 0
          this.currentLevel['level_completed'] = false
          this.currentLevel['seconds_per_question'] = levelInfo['seconds_per_question']
        }
      }).catch(err => {
        console.log('Error loading', err)
      })
    },
    goBackToShare () {
      this.$router.push({ path: '/leik-lokid/' })
    },
    clickAnswer (queKey, answer, timeout) {
      this.hasTimerStart = false
      if (this.selected || timeout) {
        this.showLoader = true
        this.freePlayValidate = null
        API.meInstance.post(
          '/free-play/validate/',
          { 'question_key': queKey, 'answer': answer }
        ).then((res) => {
          this.freePlayValidate = res.data.data.answer
          this.freePlayInfo.answered_correct = res.data.data.answered_correct
          this.freePlayInfo.answered_wrong = res.data.data.answered_wrong
          if (res.data.data.answer) {
            const pointsPerAnswer = parseInt(this.currentLevel.points_per_answer)
            const secondsPerQuestion = parseInt(this.currentLevel.seconds_per_question)
            const reductionPoints = Math.round(pointsPerAnswer / secondsPerQuestion)
            const bonusPoints = pointsPerAnswer - (parseInt(res.data.data.consumed_time) * reductionPoints)
            this.totalScore += pointsPerAnswer + bonusPoints
          }
          this.showLoader = false
          setTimeout(() => {
            this.currentLevelAnswers = this.currentLevelAnswers.map((val, index) => (
              index === this.questionIndex ? this.freePlayValidate : val
            ))
            this.questionIndex++
            if (this.questionIndex === this.questionLimit) {
              this.showFinalScore = true
            } else {
              this.showTimerLoader = true
            }
          }, timeout ? 10 : 3000)
        })
      } else {
        this.$notify({
          customClass: 'error-msg',
          message: this.$createElement('i', { style: 'color: #f7653a' }, 'Vinsamlegast veldu hvaða valkost sem er.')
        })
      }
    },
    continuePlay () {
      this.totalScore = 0
      this.showFinalScore = false
      this.getQuestions()
      this.proceed()
    },
    proceed () {
      this.selected = null
      this.freePlayValidate = null
      this.showTimerLoader = false
      this.hasTimerStart = true
    },
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  overflow: hidden auto;
}
.btn-svara, .btn-spila {
  padding: 1.5rem 16rem;
}
.question-block-inner {
  opacity: 1;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadingEffect;
  animation-name: fadingEffect;
  background: transparent;
  &.el-loading-parent--relative {
    opacity: 0 !important;
    animation-duration: .5s !important;
    animation-fill-mode: both !important;
    animation-name: fadingOffEffect !important;
  }

  .question-index {
    font-size: 14px;
    font-weight: 300;
    text-align: left;
  }
  .question {
    background: #FFFFFF;
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    font-size: 16px;
    line-height: 150%;
    color: #011627;
    padding: 15px 80px;
    max-width: 700px;
    margin: 0 auto;
    margin-bottom: 42px;
  }
  .radio {
    padding-top: 0.5rem;
    &:focus, &:active {
      border: initial;
    }
  }
}
.selection {
  border: 1px solid #CCD0D4;
  background: #FFFFFF;
  border-radius: 10px;
  text-align: left;
  margin-bottom: 29px;
  width: 338px;
  display: inline-block;
  vertical-align: top;
  &.valid {
    border: 1px solid #2EC4B6;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    label {
      background: #D5F3F0;
      border-radius: 10px;
    }
    input:checked ~ .checkmark {
      background: #2EC4B6;
      border: none;
      opacity: 1;
    }
  }
  &.invalid {
    border: 1px solid #FF6A6A;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    label {
      background: #FFE1E1;
      border-radius: 10px;
    }
    input:checked ~ .checkmark {
      background: #FF6A6A;
      border: none;
      opacity: 1;
    }
  }

  input {
    opacity: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 20px;
    cursor: pointer;
  }
  label {
    padding: 1.2rem 1.5rem;
    padding-left: 5rem;
    line-height: 132%;
    display: flex;
    align-items: center;
    height: 100%;
  }
  .checkmark {
    margin-left: 1rem;
    position: absolute;
    &:after {
      content: "";
      position: absolute;
      display: block;
      // background-image: url(/static/images/tick-mark.svg);
      width: 33px;
      height: 50%;
      background-repeat: no-repeat;
      background-size: contain;
      top: 4px;
      left: 3px;
    }
  }
  .radio-label {
    font-size: 16px;
    color: #011627;
    display: flex;
    align-items: baseline;
    position: relative;
    font-weight: 400;
    line-height: 132%;
    display: flex;
    &.selected {
      font-weight: 600;
      line-height: 19px;
    }
  }
}
.free-play-details {
  text-align: center;
  padding: 115px 50px 50px;
  height: 100%;
  display: flex;
  position: relative;
  .cross-btn {
    display: none;
  }
  .free-play-inner {
    width: 712px;
    margin-left: auto;
    margin-right: auto;
    /deep/.el-loading-mask {
      background: rgba(255, 255, 255, 0.5);
    }
    >div {
      display: flex;
      flex-direction: column;
    }
    .timer-wrapper {
      order: 1;
      margin-bottom: 40px;
    }
    .status-page {
      order: 3;
      position: relative;
      left: auto;
      top: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 25px;
      /deep/.status-bar-inner {
        height: 20px;
        width: 20px;
        margin: 0 calc(5px / 2);
        border: none;
      }
    }
    .answer {
      order: 2;
      color: #2DADA1;
      font-weight: 400;
      line-height: 132%;
      margin-bottom: 18px;
      font-size: 18px;
      min-height: 24px;
      &.invalid {
        color: #FF6A6A;
      }
    }
    .hyphen {
      order: 4;
      margin: 10px 0 17px 22px;
      &::before {
        content: "";
        display: flex;
        border: 1px solid #FCBD00;
        width: 19px;
      }
    }
    .question-block-inner {
      order: 5;
      .radio {
        margin: 20px 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
    }
  }

  .total-scrore {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    width: 176px;
    padding: 10px;
    font-weight: 400;
    font-size: 20px;
    color: #FCBD00;
    background: #011627;
    border-radius: 0 0 10px 10px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-weight: 400;
    font-size: 26px;
    line-height: 1;
    animation-fill-mode: both;
    animation: totalScoreAnimate 1s;
    span {
      font-weight: 400;
      font-size: 12px;
      line-height: 132%;
    }
  }

  & ~ .status-image {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 89px;
      height: 86px;
    }
  }
}
.points-outer{
  margin-bottom: 10px;
  opacity: 1 !important;
   &.el-loading-parent--relative {
    opacity: 1 !important;
    animation-duration: .5s !important;
    animation-fill-mode: both !important;
    animation-name: fadingOffEffect !important;
  }
}
.cross-btn {
  a, button {
    top: 0;
    border: none;
    position: absolute;
    right: 0;
    background: #FCBD00;
    padding: 0px 30px;
    font-size: 55px;
    color: #696865;
    // line-height: 69px;
    color: #696865;
    &:hover {
      text-decoration: none;
    }
  }
}
.status-image {
  img {
    width: 110px;
    height: 110px;
  }
}
.point-circle {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.15);
  border: 3px solid transparent;

  .animate-svg{
    box-sizing: border-box;
    height: 100%;
    right: -3px;
    position: absolute;
  }
  .animate-svg-circle {
    fill: none;
    stroke: black;
    stroke-width: 3;
    stroke-dasharray: 360;
    stroke-dashoffset: 720;
    animation: rotate 2s linear 1;
  }

  &:first-child{
    margin-right: 5%;
  }
  &:last-child{
    margin-left: 15px;
  }
  &.correct {
    border-color: #85DB7E;
    .circle-inner{
      border-top-color: #85DB7E;
      border-left-color: #85DB7E;
    }
    .animate-svg-circle{
      color: #85DB7E;
      stroke: #85DB7E;
    }
  }
  &.wrong {
    border-color: #EF856B;
    .circle-inner{
      border-top-color: #EF856B;
      border-left-color: #EF856B;
    }
    .animate-svg-circle{
      color: #EF856B;
      stroke: #EF856B;
    }
  }
  &.border-line{
    border-color: transparent;
  }
  .points-inner{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .user-points {
    font-size: 68px;
    line-height: 1;
    // font-family: 'Archer Medium', sans-serif;
    padding-top: 0;
  }
}
.question-text {
    font-size: 16px;
    padding-bottom: 15px;
}

.tag-text {
  font-size: 14px;
}

.final-score-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: url('/static/images/free-play-greet-desktop.jpg');
  background-size: cover;
  overflow: hidden auto;
  background-position: bottom;
  .inner {
    padding: 63px 18px 32px;
    width: 500px;
    margin: 0 auto 225px;
    h3 {
      --height: 34px;
      text-align: center;
      margin: 0 0 18px;
      font-weight: 600;
      font-size: 28px;
      line-height: var(--height);
      min-height: var(--height);
      color: #FFFFFF;
    }
    .score-info {
      padding: 12px;
      background: #011627;
      box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 22px;
      min-height: 129px;
      .txt {
        font-weight: 400;
        font-size: 10px;
        line-height: 132%;
        color: #FFFFFF;
      }
      .total {
        color: #FFB62F;
        font-weight: 600;
        font-size: 42px;
        line-height: 132%;
      }
      .divider {
        border: 0.5px solid #5C6063;
        margin-bottom: 10px;
        width: 233px;
      }
      .out-of {
        font-weight: 400;
        font-size: 12px;
        line-height: 132%;
        color: #FFFFFF;
        margin-bottom: 7px;
      }
    }
    h5 {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #FFFFFF;
      text-align: center;
    }
    .status-page {
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/.status-bar-inner {
        margin: 0 4px;
        height: 20px;
        width: 20px;
        &.false {
          background: #FF6A6A;
        }
      }
    }
  }
  .btn-wrapper {
    padding: 0px 18px 32px;
    width: 338px;
    margin: 0 auto;
    a {
      text-align: center;
    }
    .button {
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
      padding-left: 10px;
      padding-right: 10px;
      width: 100%;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:first-child {
        margin-bottom: 14px;
      }
      &:last-child {
        background: #FFFFFF;
      }
    }
  }
}

.club-signing {
  margin-top: 20px;
}

@keyframes rotate {
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes totalScoreAnimate {
  0% { transform: translateY(-62px); }
  100% { transform: translateY(0px); }
}
@keyframes totalScoreMobileAnimate {
  0% { transform: translateX(100%); }
  100% { transform: translateX(0px); }
}

@media (max-width: 767px) {
  .cross-btn button {
    width: initial;
    padding: 3px 22px;
    line-height: 62px;
    top: 68px;
  }
  .free-play-details {
    padding: 52px 20px 0 20px;
    // overflow: hidden auto;
    .free-play-inner {
      width: 100%;
      .timer-wrapper {
        margin-bottom: 28px;
      }
      .status-page {
        order: 2;
        margin-bottom: 16px;
        /deep/.status-bar-inner {
          height: 14px;
          width: 14px;
          margin: 0 calc(4px / 2);
        }
      }
      .answer {
        order: 3;
        font-size: 16px;
        margin-bottom: 10px;
      }
      .question-block-inner {
        .question {
          margin-bottom: 20px;
        }
      }
    }

    .total-scrore {
      border-radius: 10px 0px 0px 10px;
      padding: 8px 20px 8px 16px;
      left: auto;
      top: 16px;
      width: auto;
      font-size: 20px;
      flex-direction: row;
      align-items: baseline;
      z-index: 0;
      animation-fill-mode: both;
      animation: totalScoreMobileAnimate 1s;
      span {
        margin-left: 3px;
      }
    }

    & ~ .status-image {
      img {
        width: 41px;
        height: 40px;
      }
    }
  }
  .selection {
    width: 100%;
    margin-bottom: 10px;
  }
  .point-circle {
    .animate-svg {
      right: -33px;
    }
    width: 90px;
    height: 90px;
    .user-points {
      font-size: 50px;
    }
  }
  .final-score-page {
    background: url('/static/images/free-play-greet-mobile.jpg');
    background-size: cover;
    .inner {
      width: 100%;
      margin-bottom: auto;
      flex: 1;
      .status-page {
        /deep/.status-bar-inner {
          height: 14px;
          width: 14px;
        }
      }
    }
    .btn-wrapper {
      width: 100%;
    }
  }
}
</style>
